import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import classNames from 'classnames';
import React from 'react';
import { useBootstrapPrefix } from './ThemeProvider';
var Table = React.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
    className = _ref.className,
    striped = _ref.striped,
    bordered = _ref.bordered,
    borderless = _ref.borderless,
    hover = _ref.hover,
    size = _ref.size,
    variant = _ref.variant,
    responsive = _ref.responsive,
    props = _objectWithoutPropertiesLoose(_ref, ["bsPrefix", "className", "striped", "bordered", "borderless", "hover", "size", "variant", "responsive"]);
  var decoratedBsPrefix = useBootstrapPrefix(bsPrefix, 'table');
  var classes = classNames(className, decoratedBsPrefix, variant && decoratedBsPrefix + "-" + variant, size && decoratedBsPrefix + "-" + size, striped && decoratedBsPrefix + "-striped", bordered && decoratedBsPrefix + "-bordered", borderless && decoratedBsPrefix + "-borderless", hover && decoratedBsPrefix + "-hover");
  var table = /*#__PURE__*/React.createElement("table", _extends({}, props, {
    className: classes,
    ref: ref
  }));
  if (responsive) {
    var responsiveClass = decoratedBsPrefix + "-responsive";
    if (typeof responsive === 'string') {
      responsiveClass = responsiveClass + "-" + responsive;
    }
    return /*#__PURE__*/React.createElement("div", {
      className: responsiveClass
    }, table);
  }
  return table;
});
export default Table;